import React from 'react';

// shared component
import { ListLayoutRow as Row, ListLayoutCell as Cell } from '../../../components/ListLayout';
import { Gear } from '../../../components/Svg';
import { Avatar } from '../../../components/Avatar';
import { ItemDropdown } from '../../../components/ItemDropdown';
import { variables } from '../../../components/variables';

// self component
import { Menu } from './components/Menu';
import { UserMenu } from './components/UserMenu';

import { useMenuData } from './useMenuData';
import { globalStyle } from '../../../GlobalStyle';

globalStyle`
  .user-top-menu-animation-container {
    z-index: 100000 !important;
  }

  .user-top-menu-popup.top-menu-dropdown__popup {
    padding: 10px 0 !important;
    border-radius: 2px;
  }
`;

type UserTopMenuProps = {};

export const UserTopMenu: React.FC<UserTopMenuProps> = () => {
    // hooks
    const data = useMenuData();

    return (
        <div>
            <Row marginTop="12" marginRight="15">
                <Cell marginRight="12">
                    {data.navigation && data.navigation.length ? (
                        <ItemDropdown
                            animationContainerClass={'user-top-menu-animation-container'}
                            title={(isActive) => (
                                <Gear
                                    fill={
                                        isActive
                                            ? variables.colors['brand-primary-blue']
                                            : variables.colors['road-grey-900']
                                    }
                                />
                            )}
                        >
                            <Menu data={data} />
                        </ItemDropdown>
                    ) : null}
                </Cell>
                <Cell>
                    <ItemDropdown
                        animationContainerClass={'user-top-menu-animation-container'}
                        title={(isActive) => <Avatar isActive={isActive}>{data.currentUser}</Avatar>}
                    >
                        <UserMenu userName={data.currentUser} userEmail={data.currentUserEmail} />
                    </ItemDropdown>
                </Cell>
            </Row>
        </div>
    );
};
